import React, { memo } from 'react'

import {
  Button, FavoriteFilled, FavoriteOutlined, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const likedIcon = <Icon svgComponent={FavoriteFilled} size={iconSize} notSpaced />
const likeIcon = <Icon svgComponent={FavoriteOutlined} size={iconSize} notSpaced />

// The heart and count shared by the 3D model footer and the image modal. Each caller styles it
// for its own row through `customClass` and owns the like state and the login check. `title`
// names the liked item in the label where the row shows several items' actions.
function LikeToggle({
  isLiked,
  likeCount,
  isToggling,
  onClick,
  customClass,
  title = '',
}) {
  const t = useTranslation()
  const label = title
    ? t(isLiked ? 'like.unlikeModel' : 'like.likeModel', { title })
    : t(isLiked ? 'like.unlike' : 'like.like')

  return (
    <Button
      icon={isLiked ? likedIcon : likeIcon}
      type="secondary"
      size="small"
      variant="with-icon"
      actionType="button"
      customClass={customClass}
      aria-label={label}
      aria-pressed={isLiked}
      onClick={onClick}
      disabled={isToggling}
    >
      {likeCount}
    </Button>
  )
}

LikeToggle.propTypes = {
  isLiked: bool.isRequired,
  likeCount: number.isRequired,
  isToggling: bool.isRequired,
  onClick: func.isRequired,
  customClass: string.isRequired,
  title: string,
}

export default memo(LikeToggle)
